const emailPattern = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
const urlPattern = /\b(?:https?:\/\/|www\.|wa\.me\/|t\.me\/)\S+/i;
const whatsappPattern = /\b(?:whatsapp|telegram|signal|instagram|facebook|dm me|text me|call me)\b/i;
const phonePattern = /(?:\+?\d[\d\s\-()]{9,}\d)/;

export function findRestrictedMessageContent(value: string | null | undefined) {
  const content = value?.trim() || "";

  if (!content) {
    return null;
  }

  if (emailPattern.test(content)) {
    return "Email addresses are blocked. Keep communication inside PropTRUST.";
  }

  if (urlPattern.test(content)) {
    return "Outside links are blocked. Share updates inside PropTRUST instead.";
  }

  if (whatsappPattern.test(content)) {
    return "Requests to move to outside apps are blocked to protect everyone in the transaction.";
  }

  if (phonePattern.test(content)) {
    return "Phone numbers are blocked. Use PropTRUST voice and video calls instead.";
  }

  return null;
}
